import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'

import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import MenuItem from '@material-ui/core/MenuItem'
import Menu from '@material-ui/core/Menu'
import TextField from '@material-ui/core/TextField'

import EditIcon from '@material-ui/icons/Edit'
import FolderIcon from '@material-ui/icons/Folder'
import MoreVertIcon from '@material-ui/icons/MoreVert'

import { RenjuBoardCard, CustomizedSnackbar, TitleGrid, ControlCard, Word } from '../../../containers'
import { MenuAppBar } from '../../../Parts/MenuAppBar'
import StoreBoardCard from '../containers/StoreBoardCard'
import * as constants from '../../../constants'
import ConfirmDialog from '../../../components/Common/ConfirmDialog'
import { WID } from '../../../constants/Language';

const stylesWebBoardMenu = theme => ({
  menuIcon: {
    color: theme.palette.common.white
  }
})

class WebBoardMenu extends React.Component {
  state = {
    anchorEl: null,
  }

  handleOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  handleClick = (name) => () => {
    if (name === 'NewBoard' && this.props.onNewBoard) {
      this.props.onNewBoard()
    }
    else if (name === 'Update' && this.props.onUpdate) {
      this.props.onUpdate()
    }
    else if (name === 'Save' && this.props.onSave) {
      this.props.onSave()
    }
    else if (name === 'ChangeName' && this.props.onChangeName) {
      this.props.onChangeName()
    }
    this.setState({ anchorEl: null })
  }

  render() {
    const { classes, disabledNewBoard, disabledUpdate, disabledSave, disabledChangeName } = this.props
    const { anchorEl } = this.state
    return (
      <React.Fragment>
        <IconButton onClick={this.handleOpen} className={classes.menuIcon}>
          <MoreVertIcon/>
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          <MenuItem disabled={disabledNewBoard} onClick={this.handleClick('NewBoard')}>
            <Word wid={WID.RENJU_BOARD_MENU.NEW_BOARD}/>
          </MenuItem>
          <MenuItem disabled={disabledUpdate} onClick={this.handleClick('Update')}>
            <Word wid={WID.RENJU_BOARD_MENU.SAVE}/>
          </MenuItem>
          <MenuItem disabled={disabledSave} onClick={this.handleClick('Save')}>
            <Word wid={WID.RENJU_BOARD_MENU.SAVE_AS}/>
          </MenuItem>
          <MenuItem disabled={disabledChangeName} onClick={this.handleClick('ChangeName')}>
            <Word wid={WID.RENJU_BOARD_MENU.RENAME}/>
          </MenuItem>
        </Menu>
      </React.Fragment>
    )
  }
}

WebBoardMenu = withStyles(stylesWebBoardMenu, { withTheme: true })(WebBoardMenu)


const stylesForMenuAppBarActions = theme => ({
  icon: {
    width: theme.spacing.unit * 3,
    height: theme.spacing.unit * 3,
    color: theme.palette.common.white,
  },
})

const MenuAppBarActions = withStyles(stylesForMenuAppBarActions, { withTheme: true })((props) => {
  const { classes, theme, mode, card, cardTitle, editingBoardId, disabledNewBoard, disabledUpdate, disabledSave, disabledChangeName, webBoardMenuProps, isEdited, width, fileTitleCardProps } = props

  return (
    <div>
      {width < theme.breakpoints.values.md && (
        <IconButton onClick={fileTitleCardProps.handleClickMode(mode)}>
          {mode === constants.webBoardModeType.EDIT ? (
            <FolderIcon className={classes.icon}/>
          ) : mode === constants.webBoardModeType.FOLDER ? (
            <EditIcon className={classes.icon}/>
          ) : (
            <React.Fragment></React.Fragment>
          )}
        </IconButton>
      )}
      <WebBoardMenu
        disabledNewBoard={disabledNewBoard}
        disabledUpdate={disabledUpdate}
        disabledSave={disabledSave}
        disabledChangeName={disabledChangeName}
        onSave={webBoardMenuProps.handleSave(cardTitle, card)}
        onUpdate={webBoardMenuProps.handleUpdate(editingBoardId, card)}
        onNewBoard={webBoardMenuProps.handleNewBoard(isEdited)}
        onChangeName={webBoardMenuProps.handleChangeName(cardTitle, card)}
        isEdited={isEdited}
      />
    </div>
  )
})

const styles = theme => ({
})


class WebBoard extends React.Component {
  constructor(props) {
    super(props)
    this.props.init()
  }

  render() {
    const { classes, theme, user, isAuthStateChange, bid, mode, editingBoardId, card, cardTitle, cardSubheader, width, boardTitle, hasRecord, isEdited, disabledNewBoard, disabledUpdate, disabledSave, disabledChangeName, openNewBoardCnfDlg, openSaveCnfDlg, openChangeNameCnfDlg, webBoardMenuProps, fileTitleCardProps, newBoardCnfDlgProps, saveCnfDlgProps, changeNameCnfDlgProps } = this.props
    var styles = {
      grid: {
        marginBottom: theme.spacing.unit,
      },
      boardGrid: {
        marginBottom: theme.spacing.unit * 10,
      }
    }
    return (
      <div>
        <MenuAppBar
          title={cardTitle ? cardTitle : (<Word wid={WID.MENU_APP_BAR.WEB_BOARD}/>)}
          actions={
            <MenuAppBarActions
              {...{ mode, card, cardTitle, cardSubheader, hasRecord, editingBoardId, disabledNewBoard, disabledUpdate, disabledSave, disabledChangeName, webBoardMenuProps, isEdited, width, fileTitleCardProps }}
            />
          }
        />
        <TitleGrid
          titleType='board'
        >
          {isAuthStateChange === false || bid < 0 ? (
            <div></div>
          ) : !Boolean(user) ? (
            <React.Fragment>
              <Grid item md={7} xs={12} style={styles.boardGrid}>
                <RenjuBoardCard bid={bid}/>
              </Grid>
              <Grid item md={5} xs={12} style={styles.grid}>
                <ControlCard bid={bid}/>
              </Grid>
            </React.Fragment>
          ) :
          width >= theme.breakpoints.values.md ? (
            <React.Fragment>
              <Grid item md={7} xs={12} style={styles.boardGrid}>
                <RenjuBoardCard bid={bid}/>
              </Grid>
              <Grid item md={5} xs={12} style={styles.grid}>
                <ControlCard bid={bid}/>
                <StoreBoardCard isEdited={isEdited}/>
              </Grid>
            </React.Fragment>
          ) : (
            <Grid item xs={12} style={styles.boardGrid}>
              {mode === constants.webBoardModeType.EDIT ? (
                <React.Fragment>
                  <RenjuBoardCard bid={bid}/>
                  <ControlCard bid={bid}/>
                </React.Fragment>
              ) : mode === constants.webBoardModeType.FOLDER ? (
                <StoreBoardCard isEdited={isEdited}/>
              ) : (
                <div></div>
              )}
            </Grid>
          )}
        </TitleGrid>
        <CustomizedSnackbar/>
        <ConfirmDialog
          open={openNewBoardCnfDlg}
          title={<Word wid={WID.NEW_BOARD_CONFIRM_DIALOG.TITLE}/>}
          content={<Word wid={WID.NEW_BOARD_CONFIRM_DIALOG.CONTENT}/>}
          onOK={newBoardCnfDlgProps.handleOK}
          onClose={newBoardCnfDlgProps.handleClose}
        />
        <ConfirmDialog
          open={openSaveCnfDlg}
          title={<Word wid={WID.SAVE_CONFIRM_DIALOG.TITLE}/>}
          content={
            <TextField
              label={<Word wid={WID.SAVE_CONFIRM_DIALOG.TITLE_LABEL}/>}
              value={boardTitle}
              onChange={saveCnfDlgProps.handleChangeText('boardTitle')}
              helperText={<Word wid={WID.SAVE_CONFIRM_DIALOG.LIMIT_HELPER_TEXT}/>}
              className={classes.boardTitle}
            />
          }
          onOK={saveCnfDlgProps.handleOK(card, boardTitle)}
          onClose={saveCnfDlgProps.handleClose}
        />
        <ConfirmDialog
          open={openChangeNameCnfDlg}
          title={<Word wid={WID.RENAME_CONFIRM_DIALOG.TITLE}/>}
          content={
            <TextField
              label={<Word wid={WID.RENAME_CONFIRM_DIALOG.TITLE_LABEL}/>}
              value={boardTitle}
              onChange={changeNameCnfDlgProps.handleChangeText('boardTitle')}
              helperText={<Word wid={WID.RENAME_CONFIRM_DIALOG.LIMIT_HELPER_TEXT}/>}
              className={classes.boardTitle}
            />
          }
          onOK={changeNameCnfDlgProps.handleOK(editingBoardId, boardTitle)}
          onClose={changeNameCnfDlgProps.handleClose}
        />
      </div>
    )
  }
}

export default withStyles(styles, { withTheme: true })(WebBoard)



// WEBPACK FOOTER //
// ./src/Pages/WebBoard/components/WebBoard.js